import { onBeforeUnmount, onMounted } from 'vue';
import {
  loadOpenaiPixel,
  trackOpenaiLead,
  trackOpenaiPageView,
} from 'shared/helpers/openaiPixel';

const CTA_SELECTOR = '[data-lp-cta]';

// Pixel do ChatGPT Ads do revendedor: page_viewed ao abrir e lead_created no
// clique do botão principal.
export function useOpenaiPixel(landing) {
  if (!landing.openaiPixelId) return;

  const onClick = event => {
    if (!event.target.closest(CTA_SELECTOR)) return;
    trackOpenaiLead();
  };

  onMounted(() => {
    loadOpenaiPixel(landing.openaiPixelId);
    trackOpenaiPageView(landing.page, document.title);
    document.addEventListener('click', onClick, true);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', onClick, true);
  });
}
